import { apiServiceConstants } from "../../../../constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
import { ContactInfo, ExtraArgs, NumberType, profileEditParams, RespProfileEditInterface, RespProfileEditModel, Role, RoleBasedPermission, UserData } from "./Models/MyProfile.model";


const getProfileEditDetails = async (params: profileEditParams): Promise<RespProfileEditInterface> => {
    const respApiResult = await apiService
        .apiCall(
            `user/v2/${params.guid}/?reg_code=${utilService.getNetwork()}`,
            params,
            apiServiceConstants.GET,
            utilService.getDeviceType()
        )
        .then((res) => {
            const profileEditResp = res as RespProfileEditModel;
            const profileEditResponse =
                setProfileEditModel(
                    profileEditResp
                );
            const result: RespProfileEditInterface = {
                isSuccess: profileEditResp.isSuccess,
                displayProfileEditContainer: profileEditResponse,
                status: profileEditResp.status,
                message: profileEditResp.message,
            };
            return result;
        })
        .catch((err) => {
            const result: RespProfileEditInterface = {
                isSuccess: false,
                message: err.message,
                status: err.status,
                displayProfileEditContainer: []
            };
            return result;
        });

    return respApiResult;
};

const setProfileEditModel = (payload: RespProfileEditModel): any => {
    let ProfileEditArray = payload.result?.map((object: any) => {
        return {
            userData: mapUserData(object.user_data),
            extraArgs: mapExtraArgs(object.extra_args)
        };
    });
    return ProfileEditArray;
};

const mapUserData = (data: UserData): any => {
    var userDataObject = {
        image: mapImageData(data.image),
        id: data.id,
        username: data.username,
        email: data.email,
        firstName: data.first_name,
        groups: data.groups,
        lastName: data.last_name,
        displayName: data.display_name,
        mobileNumber: data.mobile_number,
        alternateNumber: data.alternate_number,
        pager: data.pager,
        roles: mapRoles(data.roles),
        profilePic: data.profile_pic,
        contactPreference: data.contact_preference,
        guid: data.guid,
        color: data.color,
        unavailableWhenNotOncall: data.unavailable_when_not_oncall,
        countryCode: data.country_code,
        contactInfo: mapContactInfo(data.contact_info),
        primaryCanSendSms: data.primary_can_send_sms,
        secondaryCanSendSms: data.secondary_can_send_sms,
        roleBasedPermission: mapRoleBasedPermission(data.role_based_permission)
    };
    return userDataObject;
};

const mapRoleBasedPermission = (data: RoleBasedPermission) => {
    var roleBasedPermissionObject = {
        myScheduleCard: data.my_schedule_card,
        statusBoard: data.status_board,
        coverageTab: data.coverage_tab,
        onBehalf: data.on_behalf,
        onCallLookUp: data.on_call_look_up,
        editCareTeam: data.edit_care_team,
        editSupportStaff: data.edit_support_staff,
        addCareTeam: data.add_care_team,
        addSupportStaff: data.add_support_staff,
        notifyCareTeam: data.notify_care_team,
        nurseManagement: data.nurse_management,
        newCustomColumn: data.new_custom_column,
        addAdditionalColumn: data.add_additional_column,
        admitPatient: data.admit_patient,
        myPatients: data.my_patients,
        messagePermission: data.message_permission,
        unassignShift: data.unassign_shift,
        mediaShare: data.media_share
    };
    return roleBasedPermissionObject;
}

const mapRoles = (payload: Array<Role>): any => {
    let roleArray = payload.map((object: any) => {
        return {
            name: object.name,
            id: object.id
        };
    });
    return roleArray;
};

const mapContactInfo = (payload: Array<ContactInfo>): any => {
    let contactInfoArray = payload.map((object: any) => {
        return {
            id: object.id,
            number: object.number,
            numberStatus: object.number_status,
            canSendSms: object.can_send_sms,
            canCall: object.can_call,
            numberType: object.numer_type
        };
    });
    return contactInfoArray;
};

const mapExtraArgs = (data: ExtraArgs) => {
    var extraArgsObject = {
        numberTypes: mapNumberTypes(data.number_types),
    };
    return extraArgsObject;
};

const mapNumberTypes = (payload: Array<NumberType>): any => {
    let numberTypeArray = payload.map((object: any) => {
        return {
            value: object.value,
            key: object.key
        };
    });
    return numberTypeArray;
};

//TO DO
const mapImageData = (profilePic: string) => {
    {
        if (profilePic !== null) {
          if(! profilePic.includes("://thecallcentral.com")){
          profilePic = utilService.getBaseUrl() + profilePic;
          }
        } else {
          profilePic = "assets/images/defaultProfilePic.png";
        }
        return profilePic;
      };
    }

const handleErrorResponse = () => { };

export const MyProfileEditService = {
    getProfileEditDetails,
    handleErrorResponse,
};